export default {"src":"/_next/static/media/IconLargeGearIntercoms.043eea1c.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};